import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import VueI18n from 'vue-i18n';
import ru from '@/locales/ru.json';

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/vue-select'
import '@/libs/toastification'
import dirtyForm from "@/mixins/dirtyForm";
import setPreloader from "@/mixins/setPreloader";

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueI18n);
Vue.use(BootstrapVue);

// Composition API
Vue.use(VueCompositionAPI)

// Laravel Echo Configuration for Real-time Communication
// DISABLED: WebSocket server not running
// Uncomment when you have Laravel WebSockets or Pusher configured

// import Echo from 'laravel-echo'
// window.Pusher = require('pusher-js')

// // Configure Echo instance
// if (process.env.NODE_ENV === 'development') {
//   window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.VUE_APP_PUSHER_APP_KEY || 'tred-key',
//     wsHost: window.location.hostname,
//     wsPort: 6001,
//     wssPort: 6001,
//     forceTLS: false,
//     disableStats: true,
//     enabledTransports: ['ws', 'wss'],
//     auth: {
//       headers: {
//         Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
//       },
//     },
//   })
// } else {
//   // Production configuration - adjust as needed
//   window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.VUE_APP_PUSHER_APP_KEY || 'tred-key',
//     wsHost: process.env.VUE_APP_WEBSOCKET_HOST || 'tred.uz',
//     wsPort: process.env.VUE_APP_WEBSOCKET_PORT || 6001,
//     wssPort: process.env.VUE_APP_WEBSOCKET_SSL_PORT || 6001,
//     forceTLS: true,
//     disableStats: true,
//     enabledTransports: ['ws', 'wss'],
//     auth: {
//       headers: {
//         Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
//       },
//     },
//   })
// }

// // Make Echo globally available
// Vue.prototype.$echo = window.Echo

// Set window.Echo to null to prevent errors in components that check for it
window.Echo = null
Vue.prototype.$echo = null

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css')

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

require('@/style/style.scss') ;

Vue.config.productionTip = false

Vue.mixin(dirtyForm)
Vue.mixin(setPreloader)

const messages = {
    ru,
};

const i18n = new VueI18n({
    locale: 'ru',
    messages,
});

new Vue({
    router,
    i18n,
    store,
    render: h => h(App),
}).$mount('#app')
